import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/modules/common/modalReducer";
import "./TransferAlert.scss";

const TransferAlert = () => {
    const dispatch = useDispatch();
    const msg = useSelector((state) => state.modalReducer.msg);

    const closeTransferAlert = () => {
        dispatch(closeModal());
    };

    return (
        <div className="transferModal">
            <div className="transferModal_header">안내</div>
            <div className="transferModal_body">
                <p className="transferModal_body_message">{msg}</p>
                <button className="transferModal_body_button" onClick={closeTransferAlert}>
                    확인
                </button>
            </div>
        </div>
    );
};

export default TransferAlert;
